import React from 'react';
import InputField from '../../../../components/inputField/InputField';
import PageMessages from '../../../../config/translations/PageMessages';

function FieldWithInfo({ children, ...props }) {
    return (
        <InputField
            {...props}
            infoMessage={PageMessages.sei.propostaIndicador.inputs?.[props?.id] ?? null}
        >
            {children}
        </InputField>
    );
}

export default FieldWithInfo;
